import { Box, Typography } from '@mui/material'
import React from 'react'

const SectionTitle = ({firstTitleWord, secondTitleWord, textStyle, sx, linesx, firstWordStyle, secondWordStyle}) => {
  return (
    <Box
              sx={{
              width:'100%',
              display:'flex',
              flexDirection:'row',
              alignItems:'center',
              // justifyContent:'space-between',
              paddingY:'3rem',
              ...sx
              }}
            >
              <Box // line beside title
              sx={{
                  height:'0.2rem',
                  width:'10rem',
                  backgroundColor:'#000',
                  alignContent:'center',
                  alignItems:'center',
                  marginRight:'2rem',
                  '@media screen and (max-width: 762px)':{
                    width:'5rem'
                  },
                  ...linesx
              }}
              />

              
              <Typography variant='h1'
                  sx={{
                  fontSize:'2rem',
                  fontFamily:"ITC Avant Garde Gothic",
                  fontStyle:'nomral',
                  textTransform:'uppercase',
                  fontWeight:'500',
                  color:'#000',
                  
                  ...textStyle
                  }}
              >{firstTitleWord} <span style={{color:'#59428A', ...secondWordStyle}}>{secondTitleWord}</span></Typography>
          </Box>
  )
}

export default SectionTitle